import moment from 'moment';

export const Helpers = {
    isProduction: process.env.NODE_ENV === "production",
    formatDate: (date: Date): string => (moment(date).format("DD/MM/YYYY")),
    formatDateFromNow: (date: Date): string => (moment(date).fromNow()),
    formatDateFull: (date: Date): string => (moment(date).format("DD/MM/YYYY hh:mm:ss"))
};